export default function DefaultButton({
  label,
  className,
  onClick,
  disabled,
  type,
}) {
  return (
    <>
      <button
        className={`w-1/2 bg-[#087E9E] py-[13px] text-white border-none shadow-sm rounded-lg cursor-pointer text-base font-semibold self-stretch leading-6 tracking-[0px] ${className} ${
          disabled ? "pointer-events-none !bg-gray-300 !text-white" : ""
        }`}
        type={type ? type : "button"}
        onClick={onClick}
        disabled={disabled}
      >
        {label}
      </button>
    </>
  );
}
